<template>
    <div>
        <template v-if="roles == true">
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left">Manage Roles</h1>
                <router-link v-if="crud_role" to="/addRole" class="btn btn-primary float-right">Add Role</router-link>
            </div>
            <table id="rolesTable" class="table" width="100%">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Created</th>
                        <th>Action</th>
                    </tr>
                </thead>
            </table>
        </template>
        <template v-if="roles == null">
            <preLoader></preLoader>
        </template>
        <template v-if="roles == false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                data : null,
                crud_role : null,
                roles : null
            };
        },
        mounted() {
          var gThat = this;
            this.$Progress.start();
            this.can('manage_company_roles|manage_company_crud_role').then(result => {
                this.crud_role = result.manage_company_crud_role;
                this.roles = result.manage_company_roles;
            }).then(result => {
                if(this.roles == true){
                    this.listRoles();
                }
            });
          window.softDelete = function(roleId){
            gThat.softDelete(roleId);
          }
        },
        methods: {
            listRoles: function(){
                var that = this;
                $('#rolesTable').DataTable({
                    processing: true,
                    serverSide: true,
                    sDom : '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>',
                    ajax: {
                        "url": "api/getRolesList",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
                        "complete": function (json, type) { //type return "success" or "parsererror"
                            if (type == "parsererror") {
                                that.$Progress.fail();
                            }else{
                                that.$Progress.finish();
                            }
                        }
                    },
                    deferRender: true,
                    columns: [
                        {data: 'name'},
                        {data: 'created_at'},
                        {data: 'id', sorting: false, render: function(data,type,full){
                            if(full.can_edit == "YES"){
                            var $url = '/editRole/'+full['id'];
                            return '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" data-toggle="tooltip" data-placement="top" title="Edit" class="action edit" ><i class="fas fa-pencil-alt"></i></a><a href="javascript:void(0);" onClick="window.softDelete('+full['id']+')"  data-toggle="tooltip" data-placement="top" title="Delete" class="action edit"> <i class="fas fa-trash-alt"></i> </a>';
                            }
                        }, visible: that.crud_role},
                    ],
                    "order": [[ 0, "desc" ]],
                });
            },
          softDelete(roleId) {
            Swal.fire({
              title: 'Are you sure?',
              text: "You want to delete this!",
              type: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
              if (result.value) {
                axios.post("/api/roleSoftDelete", {RoleId: roleId})
                    .then(res => {
                      if(res.status == 200){
                        this.showToastBox('success','Role Leave deleted successfully!');
                        this.$router.go(this.$router.currentRoute);
                        this.$Progress.finish();
                      }else{
                        this.$Progress.fail();
                        Swal.fire({
                          icon: 'error',
                          title: 'Oops...',
                          text: 'Something went wrong!',
                        })
                      }
                    })
                    .catch(err => {
                      console.log(err);
                      this.$Progress.fail();
                      this.showAlertBox('error','couldnt find requested data');
                    });
              }
            })
          }
        }
        
    }
</script>
